export class BaseModel{
  public functionCode: string;
}
